export default function utils() {
    return {
        protocol: 'https://', //No comentar en productivo
        // protocol: 'http://', // Comentar en productivo
        pagination: 10
    };
}